import {
  disableDarkContrast,
  enableDarkContrast,
} from "../host/features/color-adjustments/darkContrast";
import {
  disableHighContrast,
  enableHighContrast,
} from "../host/features/color-adjustments/highContrast";
import {
  disableHighSaturation,
  enableHighSaturation,
} from "../host/features/color-adjustments/highsaturation";
import {
  disableInvertColors,
  enableInvertColors,
} from "../host/features/color-adjustments/invertColors";
import {
  disableLightContrast,
  enableLightContrast,
} from "../host/features/color-adjustments/lightContrast";
import {
  disableLowSaturation,
  enableLowSaturation,
} from "../host/features/color-adjustments/lowSaturation";
import {
  disableMonochrome,
  enableMonochrome,
} from "../host/features/color-adjustments/monochrome";
import {
  clearAlign,
  setAlign,
} from "../host/features/content-adjustments/alignText";
import {
  disableContentMagnifier,
  enableContentMagnifier,
} from "../host/features/content-adjustments/contentMagnifier";
import {
  disableHighlightLinks,
  enableHighlightLinks,
} from "../host/features/content-adjustments/highlightLinks";
import {
  highlightTitles,
  unHighlightTitles,
} from "../host/features/content-adjustments/highlightTitles";
import {
  disableBiggerCursor,
  enableBiggerCursor,
} from "../host/features/orientation-adjustments/biggerCursor";
import {
  disableDyslexicFont,
  enableDyslexicFont,
} from "../host/features/orientation-adjustments/dyslexicFont";
import {
  hideImages,
  unhideImages,
} from "../host/features/orientation-adjustments/hideImages";
import { enableLegibleFont } from "../host/features/orientation-adjustments/legibleFont";
import {
  disablePauseAnimations,
  enablePauseAnimations,
} from "../host/features/orientation-adjustments/pauseAnimations";
import {
  disableReadingGuide,
  enableReadingGuide,
} from "../host/features/orientation-adjustments/readingGuide";
import {
  disableReadingMask,
  enableReadingMask,
} from "../host/features/orientation-adjustments/readingMask";

const data = {
  keyTabs: [{ title: "Accessbility Profiles" }, { title: "Customize" }],
  footerTabs: [{ title: "Feedback" }, { title: "Reset Settings" }],
  customizeTabs: [
    { title: "Over Size Widget" },
    { title: "Content Adjustment" },
    { title: "Color Adjustments" },
    { title: "Orientation Adjustments" },
    { title: "Move Widget" },
    { title: "Hide Interface" },
  ],
  certification: [
    {
      title: "Certification",
    },
    {
      content:
        "Accessibility Statement\nEqualWeb is committed to promoting digital accessibility for people with disabilities. We are continually improving the user experience for all site visitors and applying the relevant accessibility standards. EqualWeb has taken careful measures to ensure an excellent user experience, regardless of the assistive technology being used to access this site.\n\nCertificate & Conformance Status\nThis is to confirm that this site has been reviewed by software developers and remediated to meet standards set by the WCAG 2.2 (Web Content Accessibility Guidelines 2.2) at the AA level. The WCAG 2.2 AA level covers a wide range of recommendations for making Web content more accessible. WCAG 2.2 AA level guidelines include specific details on how to develop accessible Web content. This statement certifies that specific techniques were met for the Success Criterion detailed by WCAG. As a result, this website's content has been made more accessible to a wider range of people with disabilities, including blindness and low vision, deafness and hearing loss, learning disabilities, cognitive limitations, limited movement, speech disabilities, photosensitivity, and combinations thereof. By implementing and adhering to these guidelines, this website's web content has also become more usable to users in general. Using the accessibility widget is subject to our privacy policy, which can be found on the company's website.\n\nMeasures taken to make this website more accessible\nEqualWeb’s Automatic system, team of developers, designers, and content accessibility experts has reviewed, remediated, and tested this website by performing multi-layered accessibility testing and analysis of the new and updated accessibility measures and web content. As part of the process to make this website more accessible, adjustments were made, which include JavaScript & CSS work. The process also included accessibility modifications for assistive technologies (e.g., NVDA, JAWS, etc.). Below is a complete list of accessibility modifications and functionalities made.\n\nCompatibility with browsers and assistive technology\nOur mission goal is to support the widest array of browsers and assistive technologies possible. We have therefore invested efforts to support popular systems with high market share, including Chrome, Firefox, Edge, Opera, and Safari VoiceOver on a Mac. We have also addressed JAWS and NVDA assistive technologies for Windows and Mac.\n\nIn addition, the following modifications were made during the audit to make this website accessible:",
    },
  ],
  languageList: [
    {
      url: "/language/germanDEIcon.svg",
      name: "Deutsch",
      language: "Deutsch",
      code: "de",
    },
    {
      image: "/language/englishUKIcon.svg",
      name: "English (UK)",
      language: "English",
      code: "en",
    },
    {
      image: "/language/spanishIcon.svg",
      name: "Spanish",
      language: "Spanish",
      code: "en",
    },
    {
      image: "/language/portugalIcon.svg",
      name: "Portuguese",
      language: "Portuguese",
      code: "en",
    },
    {
      image: "/language/spainIcon.svg",
      name: "España",
      language: "Spainish",
      code: "en",
    },
    {
      image: "/language/franceIcon.svg",
      name: "French",
      language: "French",
      code: "en",
    },
    {
      image: "/language/iraqIcon.svg",
      name: "الْعِرَاق",
      language: "Arabic",
      code: "en",
    },
    {
      image: "/language/indiaIcon.svg",
      name: "हिन्दी",
      language: "Hindi",
      code: "en",
    },

    {
      image: "/language/georgiaIcon.svg",
      name: "საქართველო",
      language: "Georgian",
      code: "en",
    },
    {
      image: "/language/ukraineIcon.svg",
      name: "Україна",
      language: "Ukrainian",
      code: "en",
    },
    {
      image: "/language/dutchIcon.svg",
      name: "Dutch",
      language: "Dutch",
      code: "en",
    },
    {
      image: "/language/jerseyIcon.svg",
      name: "Jèrriais",
      language: "Jersey",
      code: "en",
    },
  ],

  tabData: [
    {
      General: [
        {
          command: "Open widget",
          explanation:
            "Opens or reveals the accessibility widget or tool on the webpage.",
        },
        {
          command: "Close widget",
          explanation:
            "Closes or hides the accessibility widget or tool from the webpage.",
        },
        {
          command: "Enable [function name]",
          explanation: "Enable [ function name ] activates the function.",
        },
        {
          command: "Disable [function name]",
          explanation: "Disable [ function name ] deactivates the function.",
        },
      ],
    },
    {
      Navigation: [
        {
          command: "Go to home page",
          explanation:
            "Navigates the user back to the main homepage of the website.",
        },
        {
          command: "Refresh page",
          explanation:
            "Reloads the current page to reflect any updates or changes.",
        },
        {
          command: "Scroll [up/down/left/right]",
          explanation:
            "Moves the page in the specified direction for easier navigation.",
        },
        {
          command: "Next page / Previous page",
          explanation:
            "Navigates to the next or previous page in the browsing sequence.",
        },
      ],
    },
    {
      Gestures: [
        {
          command: "Zoom in",
          explanation:
            "Increases the page magnification for better readability and visibility.",
        },
        {
          command: "Zoom out",
          explanation:
            "Decreases the page magnification to show more content on the screen.",
        },
      ],
    },
    {
      Links: [
        {
          command: "Click on [number]",
          explanation:
            "Selects the specified numbered element or option on the screen.",
        },
        {
          command: "Click [button name]",
          explanation:
            "Activates the specified button to perform its assigned action.",
        },
        {
          command: "Select [option name]",
          explanation: "Chooses the specified option from a list or menu.",
        },
        {
          command: "Open menu '/'Close menu",
          explanation:
            "Expands or collapses the menu for navigation or selection.",
        },
      ],
    },
  ],
  profile: [
    {
      id: 0,
      title: "Motor Impaired",
      subtitle: "Keyboard navigation and voice control",
      iconUnselected:
        "/accessbilityProfile/profile/motorImpaired/motorImpaired.svg",
      iconSelected: "",
      action: "Motor Impaired",
      unSelectedAction: "Motor Impaired-unselected",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 1,
      title: "Blind",
      subtitle: "Screen reader support and audio feedback",
      iconUnselected: "/accessbilityProfile/profile/blind/blind.svg",
      iconSelected: "",
      action: "Blind",
      unSelectedAction: "Blind-unselected",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 2,
      title: "Color Blind",
      subtitle: "Adjusted contrast and color filters",
      iconUnselected: "/accessbilityProfile/profile/colorBlind/colorBlind.svg",
      iconSelected: "",
      action: "Color Blind",
      unSelectedAction: "unselected:Color Blind",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 4,
      title: "Low Vision",
      subtitle: "Larger text, high contrast mode",
      iconUnselected: "/accessbilityProfile/profile/lowVision/lowVisionP.svg",
      iconSelected: "",
      action: "Low Vision",
      unSelectedAction: "Low Vision-unselected",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 5,
      title: "Cognitive & Learning",
      subtitle: "Simplified layout and guided focus",
      iconUnselected:
        "/accessbilityProfile/profile/cognitive&learning/cognitive.svg",
      iconSelected: "",
      action: "Cognitive & Learning",
      unSelectedAction: "Cognitive & Learning-unselected",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 6,
      title: "Seizure & Epileptic",
      subtitle: "Removes flashing and reduces brightness",
      iconUnselected: "/accessbilityProfile/profile/seizure/seizure.svg",
      iconSelected: "",
      action: "Seizure & Epileptic",
      unSelectedAction: "unselected:Seizure & Epileptic",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 7,
      title: "ADHD",
      subtitle: "Minimizes distractions and enhances focus",
      iconUnselected: "/accessbilityProfile/profile/adhd/adhd.svg",
      iconSelected: "",
      action: "ADHD",
      unSelectedAction: "unselected:ADHD",
      isSelected: false,
      type: "",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: true,
      customize: false,
      isMobileActive: true,
    },
    {
      id: 8,
      title: "Highlight Links",
      subtitle:
        "Highlights all clickable links and helps users find links faster without needing to hover.",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/highlightUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/highlightLinkselected.svg",
      action: enableHighlightLinks,
      unSelectedAction: disableHighlightLinks,
      isSelected: false,
      type: "contentAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + H",
      isMobileActive: true,
    },
    {
      id: 9,
      title: "Highlight Titles",
      subtitle: "Minimizes distractions and enhances focus",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/highlightTitilesUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/hightlightTitleSelected.svg",
      action: highlightTitles,
      unSelectedAction: unHighlightTitles,
      isSelected: false,
      type: "contentAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      isMobileActive: true,
      commingSoon: false,
    },
    {
      id: 10,
      title: "Align Text",
      subtitle:
        "Align Text arranges text to the left, center or right for better readability and design.",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/alignItems.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/alignItemsSelected.svg",
      action: () => setAlign("center"),
      unSelectedAction: clearAlign,
      isSelected: false,
      type: "contentAdjustment",
      totalTapCount: 2,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [
        {
          subItemAction: () => setAlign("center"),
          subItemTitle: "Align center",
          icon: "/accessbilityProfile/profileInner/selected/alignItemsSelected.svg",
        },
        {
          subItemAction: () => setAlign("left"),
          subItemTitle: "Align left",
          icon: "/accessbilityProfile/profileInner/selected/align_left_selected.svg",
        },
        {
          subItemAction: () => setAlign("right"),
          subItemTitle: "Align right",
          icon: "/accessbilityProfile/profileInner/selected/align_right_selected.svg",
        },
      ],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + M",
      isMobileActive: true,
    },
    {
      id: 11,
      title: "Content Magnifier",
      subtitle: "",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/contentMagnifierUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/contentMagnifierSelected.svg",
      action: enableContentMagnifier,
      unSelectedAction: disableContentMagnifier,
      isSelected: false,
      type: "contentAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: "",
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      isMobileActive: false,
      commingSoon: false,
    },
    {
      id: 12,
      title: "Pause Animation",
      subtitle:
        "Pause Animation stops all moving elements on the page to reduce distractions and improve focus.",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/pauseAnimationUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/pauseAnimationSelected.svg",
      action: enablePauseAnimations,
      unSelectedAction: disablePauseAnimations,
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [
        "Motor Impaired",
        "Dyslexia",
        "Low Vision",
        "Cognitive & Learning",
        "Seizure & Epileptic",
        "ADHD",
      ],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + P",
      isMobileActive: true,
    },
    // {
    //   id: 13,
    //   title: "Tooltips",
    //   subtitle:
    //     "Tooltips display small pop-up messages when hovering over functions, providing helpful hints or additional information",
    //   iconUnselected:
    //     "/accessbilityProfile/profileInner/unselected/tooltipUnSelected.svg",
    //   iconSelected:
    //     "/accessbilityProfile/profileInner/selected/tooltipSelected.svg",
    //   action: "Tooltips",
    //   unSelectedAction: "unselected:Tooltips",
    //   isSelected: false,
    //   type: "orientationadjustments",
    //   totalTapCount: 0,
    //   currentCount: 0,
    //   subItemOf: ["Motor Impaired", "Low Vision", "Cognitive & Learning"],
    //   parentSelected: false,
    //   items: [],
    //   isVisible: true,
    //   profile: false,
    //   customize: true,
    //   tooltip: "CTRL + ALT + L",
    //   isMobileActive: false,
    // },
    {
      id: 14,
      title: "Screen Reader",
      subtitle:
        "Screen Reader reads aloud text and elements on the screen, helping visually impaired users navigate websites",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/screenReaderUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/scrennReadSelected.svg",
      action: "Screen Reader",
      unSelectedAction: "unselected:Screen Reader",
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 2,
      currentCount: 0,
      subItemOf: ["Blind"],
      parentSelected: false,
      items: [
        {
          subItemAction: "Screen Reader",
          subItemTitle: "Screen Reader",
          icon: "/accessbilityProfile/profileInner/selected/read_normal.svg",
        },
        {
          subItemAction: "Read Fast",
          subItemTitle: "Read Fast",
          icon: "/accessbilityProfile/profileInner/selected/read_fast.svg",
        },
        {
          subItemAction: "Read Slow",
          subItemTitle: "Read Slow",
          icon: "/accessbilityProfile/profileInner/selected/read_slow.svg",
        },
      ],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + S",
      isMobileActive: true,
    },
    {
      id: 15,
      title: "High Saturation",
      subtitle:
        "High Saturation increases the intensity of colors, making images and elements appear more vibrant and vivid.",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/highSaturationUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/highSaturationSelected.svg",
      action: enableHighSaturation,
      unSelectedAction: disableHighSaturation,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["Color Blind", "Low Vision"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: true,
    },
    {
      id: 20,
      title: "Low Saturation",
      subtitle:
        "Low Saturation reduces the intensity of colors, creating a softer, more muted appearance across the screen",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/lowSarUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/lowSarSelected.svg",
      action: enableLowSaturation,
      unSelectedAction: disableLowSaturation,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["Seizure & Epileptic", "ADHD"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + Y",
      isMobileActive: true,
    },
    {
      id: 25,
      title: "Monochrome",
      subtitle:
        "Desaturate removes color intensity from the screen, creating a grayscale or muted visual experience for easier viewing",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/desaturateUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/desaturateSelected.svg",
      action: enableMonochrome,
      unSelectedAction: disableMonochrome,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: true,
    },
    {
      id: 16,
      title: "High Contrast",
      subtitle:
        "High Contrast applies a high-contrast theme to improve visibility and readability, making it easier for users with visual impairments to distinguish between different elements on the page.",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/smartContastUnSelected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/smart_cont_selected.svg",
      action: enableHighContrast,
      unSelectedAction: disableHighContrast,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["Color Blind", "Cognitive & Learning"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + C",
      isMobileActive: true,
    },
    {
      id: 22,
      title: "Light Contrast",
      subtitle:
        "Light Contrast slightly increases the difference between text and background to improve visibility without harshness",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/lightContrastUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/lightContastSelected.svg",
      action: enableLightContrast,
      unSelectedAction: disableLightContrast,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: true,
    },
    {
      id: 17,
      title: "Dyslexia Fonts",
      subtitle:
        "Use easy-to-read fonts designed to boost comfort, especially for users with reading difficulties",
      iconUnselected: "/accessbilityProfile/profileInner/unselected/Df.svg",
      iconSelected: "/accessbilityProfile/profileInner/selected/dfSelected.svg",
      action: enableDyslexicFont,
      unSelectedAction: disableDyslexicFont,
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 1,
      currentCount: 0,
      subItemOf: ["Dyslexia", "Low Vision"],
      parentSelected: false,
      items: [
        {
          subItemAction: enableDyslexicFont,
          subItemTitle: "Dyslexic Friendly",
          icon: "/accessbilityProfile/profileInner/selected/dfSelected.svg",
        },
        {
          subItemAction: enableLegibleFont,
          subItemTitle: "Legible Fonts",
          icon: "/accessbilityProfile/profileInner/selected/legible_font_selected.svg",
        },
      ],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + D",
      isMobileActive: true,
    },
    {
      id: 18,
      title: "Big Cursor",
      subtitle:
        "Make the mouse pointer bigger and easier to find, helping users navigate more comfortably",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/bigCursorUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/bigCursorSelected.svg",
      action: enableBiggerCursor,
      unSelectedAction: disableBiggerCursor,
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["Low Vision"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + U",
      isMobileActive: false,
    },
    {
      id: 19,
      title: "Reading Guide",
      subtitle:
        "Display a horizontal highlight that follows your cursor to help users focus while reading content",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/readGuideUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/readGuideSelected.svg",
      action: enableReadingGuide,
      unSelectedAction: disableReadingGuide,
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["Cognitive & Learning"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: false,
    },
    {
      id: 21,
      title: "Reading Mask",
      subtitle:
        "Dim surrounding areas and highlight a focused section, helping users concentrate better while reading content",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/readingMaskUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/readingMaskSelected.svg",
      action: enableReadingMask,
      unSelectedAction: disableReadingMask,
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["ADHD"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: false,
    },
    {
      id: 23,
      title: "Dark Contrast",
      subtitle:
        "Dark Contrast significantly deepens text and background colors to enhance readability and reduce eye strain",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/darkContrastUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/darkContrastSelected.svg",
      action: enableDarkContrast,
      unSelectedAction: disableDarkContrast,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: true,
    },
    {
      id: 26,
      title: "Invert Colors",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/invertColorUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/invertColorSelected.svg",
      action: enableInvertColors,
      unSelectedAction: disableInvertColors,
      isSelected: false,
      type: "colorAdjustment",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: true,
      commingSoon: false,
    },
    // {
    //   id: 24,
    //   title: "Protanomaly",
    //   subtitle: "",
    //   iconUnselected:
    //     "/accessbilityProfile/profileInner/unselected/protanolmyUnselected.svg",
    //   iconSelected:
    //     "/accessbilityProfile/profileInner/selected/protonolmySelected.svg",
    //   action: "Protanomaly",
    //   unSelectedAction: "unselected:Protanomaly",
    //   isSelected: false,
    //   type: "colorAdjustment",
    //   totalTapCount: 3,
    //   currentCount: 0,
    //   subItemOf: [],
    //   parentSelected: false,
    //   items: [
    //     { subItemAction: "Protanomaly1", subItemTitle: "Protanomaly1" },
    //     { subItemAction: "Protanomaly2", subItemTitle: "Protanomaly2" },
    //     { subItemAction: "Protanomaly3", subItemTitle: "Protanomaly3" },
    //     { subItemAction: "Protanomaly3", subItemTitle: "Protanomaly3" },
    //   ],
    //   isVisible: true,
    //   profile: false,
    //   customize: true,
    //   tooltip: null,
    //   isMobileActive: true,
    //   commingSoon: true,
    // },
    // {
    //   id: 27,
    //   title: "Dark Mode",
    //   iconUnselected:
    //     "/accessbilityProfile/profileInner/unselected/darkModeUnselected.svg",
    //   iconSelected:
    //     "/accessbilityProfile/profileInner/selected/darkModeSelected.svg",
    //   action: "Dark Mode",
    //   unSelectedAction: "unselected:Dark Mode",
    //   isSelected: false,
    //   type: "colorAdjustment",
    //   totalTapCount: 2,
    //   currentCount: 0,
    //   subItemOf: [],
    //   parentSelected: false,
    //   items: [
    //     { subItemAction: "Dyslexia1", subItemTitle: "Dyslexia2" },
    //     { subItemAction: "Dyslexia1", subItemTitle: "Dyslexia2" },
    //     { subItemAction: "Dyslexia1", subItemTitle: "Dyslexia2" },
    //   ],
    //   isVisible: true,
    //   profile: false,
    //   customize: true,
    //   tooltip: null,
    //   isMobileActive: true,
    //   commingSoon: true,
    // },
    // {
    //   id: 28,
    //   title: "Voice Navigation",
    //   subtitle:
    //     "Control and navigate websites using voice commands, making browsing easier and more accessible for everyone",
    //   iconUnselected:
    //     "/accessbilityProfile/profileInner/unselected/voiceNavigationUnselected.svg",
    //   iconSelected:
    //     "/accessbilityProfile/profileInner/selected/voiceNavbiagtionSelected.svg",
    //   action: "Voice Navigation",
    //   unSelectedAction: "unselected:Voice Navigation",
    //   isSelected: false,
    //   type: "orientationadjustments",
    //   totalTapCount: 0,
    //   currentCount: 0,
    //   subItemOf: [],
    //   parentSelected: false,
    //   items: [],
    //   isVisible: true,
    //   profile: false,
    //   customize: true,
    //   tooltip: "CTRL + ALT + V",
    //   isMobileActive: true,
    // },
    {
      id: 29,
      title: "Hide Images",
      subtitle:
        "Remove or hide images from the page to create a cleaner, faster, and distraction-free experience",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/hideImageUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/hideImageSelected.svg",
      action: hideImages,
      unSelectedAction: unhideImages,
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + I",
      isMobileActive: true,
    },
    {
      id: 30,
      title: "Keyboard Navigation",
      subtitle:
        "Navigate and interact with widget using only the keyboard, improving accessibility and ease of use",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/keyBoardUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/keyBoardSelected.svg",
      action: "Key Board Navigation",
      unSelectedAction: "unselected:key board navigation",
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: ["Motor Impaired", "Blind"],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: null,
      isMobileActive: false,
    },
    {
      id: 31,
      title: "Dictionary",
      subtitle:
        "Instantly view definitions of selected words to improve understanding, vocabulary, and reading comprehension",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/dictonaryUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/dictonarySelected.svg",
      action: "Dictionary",
      unSelectedAction: "unselected:Dictionary",
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + K",
      isMobileActive: true,
    },
    {
      id: 32,
      title: "Page Structure",
      subtitle:
        "Display an outline of headings, landmarks, and links to help users navigate the page easily",
      iconUnselected:
        "/accessbilityProfile/profileInner/unselected/pageStructreUnselected.svg",
      iconSelected:
        "/accessbilityProfile/profileInner/selected/pageStructreSelected.svg",
      action: "Page Structure",
      unSelectedAction: "Page Structure-unselected",
      isSelected: false,
      type: "orientationadjustments",
      totalTapCount: 0,
      currentCount: 0,
      subItemOf: [],
      parentSelected: false,
      items: [],
      isVisible: true,
      profile: false,
      customize: true,
      tooltip: "CTRL + ALT + G",
      isMobileActive: true,
    },
  ],
  customizeFont: [
    {
      fontSize: [
        {
          title: "Font Sizing",
          icon: "/rangeSlider/fontSizing.svg",
          fieldName: "fontSizing",
          data: {
            action: "Bigger Text",
          },
        },
      ],
    },
    {
      letterSpacing: [
        {
          title: "Letter Spacing",
          icon: "/rangeSlider/letterSpacing.svg",
          fieldName: "letterSpacing",
          data: {
            action: "Light Space",
          },
        },
      ],
    },
    {
      wordSpacing: [
        {
          title: "Word Spacing",
          icon: "/rangeSlider/fontSpacing.svg",
          fieldName: "wordSpacing",
          data: {
            action: "Moderate Space",
          },
        },
      ],
    },
    {
      lineSpacing: [
        {
          title: "Line Spacing",
          icon: "/rangeSlider/paragraphSpacing.svg",
          fieldName: "lineSpacing",
          data: {
            action: "Line Height(1.5x)",
          },
        },
      ],
    },
  ],
  customizeColorData: [
    {
      title: "Background Color",
      icon: "/colorSlider/backgroundColor.svg",
      fieldName: "backgroundColor",
    },
    {
      title: "Text Color",
      icon: "/colorSlider/textColor.svg",
      fieldName: "textColor",
    },
  ],
} as const;

export default data;
